<script>
import {
  pageMonCompteMesCommandesProps,
  usePageMonCompteMesCommandes
} from "./mixin";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import CommandeOverview from "@/components/organisms/mon-compte/commande-overview/default";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Divider from "@/components/atoms/divider";
import Card from "@/components/molecules/card";
import CategoriesList from "@/containers/faire-mes-courses";
import Titre from "@/components/atoms/titre";
import Alert from "@/components/molecules/alert";
import BandeauCommandeEnLigne from "@/components/organisms/bandeau-commande/bandeau-commande-enligne";

import paperSheetSad from "@/assets/images/paper-sheet-sad.svg";

export default {
  name: "MesCommandes",
  components: {
    List,
    ListItem,
    CommandeOverview,
    Button,
    LazyImage,
    Divider,
    Card,
    CategoriesList,
    Titre,
    Alert,
    BandeauCommandeEnLigne
  },
  props: {
    ...pageMonCompteMesCommandesProps()
  },
  setup(props) {
    const {
      commandesEnCours,
      dernieresCommandes,
      showToutesCommandes,
      canDisplayBanner
    } = usePageMonCompteMesCommandes(props);

    return {
      commandesEnCours,
      dernieresCommandes,
      showToutesCommandes,
      paperSheetSad,
      canDisplayBanner
    };
  }
};
</script>

<template>
  <BandeauCommandeEnLigne v-if="canDisplayBanner" />

  <div class="u-pt-lg">
    <Card
      v-if="commandes.length === 0 && !hasArchive"
      elevation="sm"
      radius="md"
    >
      <div class="u-p-md">
        <div class="u-flex u-flex-align-center u-mb-lg">
          <LazyImage
            :src="paperSheetSad"
            width="90"
            height="73"
            class="u-inline-block u-mr-md"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
              class=""
            >
              Vous n'avez pas encore de commande
            </Titre>
            <p class="u-font-15">
              Retrouvez-les ici dès votre 1ère commande.
            </p>
          </div>
        </div>
      </div>
      <Divider
        dotted
        class="u-mt-md u-mb-md"
      />
      <Titre
        tag="h2"
        size="md"
        variant="primary"
        class="u-mb-md u-mt-md u-text-center"
      >
        Commencez vos courses !
      </Titre>
      <CategoriesList />
    </Card>
    <template v-else>
      <Titre
        tag="h2"
        size="sm"
        class="u-mb-sm"
      >
        Mes commandes en cours
      </Titre>
      <template v-if="commandesEnCours.length > 0">
        <List>
          <ListItem
            v-for="commande in commandesEnCours"
            :key="commande.id"
            class="u-mb-sm"
          >
            <CommandeOverview :commande="commande" />
          </ListItem>
        </List>
      </template>
      <Alert
        v-else
        has-icon
        icon-position="left"
        variant="white"
        radius="md"
        icon-name="info-circle"
        icon-color="primary-light"
        icon-size="sm"
        class="u-mb-lg u-mt-lg"
      >
        <p>Vous n’avez aucune commande en cours pour le moment</p>
      </Alert>
      <template v-if="dernieresCommandes.length > 0">
        <Titre
          tag="h2"
          size="sm"
          class="u-mb-sm u-mt-lg"
        >
          Mes dernières commandes
        </Titre>

        <List
          v-for="commande in dernieresCommandes"
          :key="commande.id"
          class="u-mb-md"
        >
          <ListItem class="u-mb-sm">
            <CommandeOverview :commande="commande" />
          </ListItem>
        </List>
      </template>
      <div class="u-text-center">
        <Button
          v-if="showToutesCommandes"
          variant="primary"
          radius="full"
          size="md"
          to="/mon-compte/toutes-mes-commandes"
        >
          Voir toutes mes anciennes commandes
        </Button>
      </div>
    </template>
  </div>
</template>
